var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaderboard-title"},[_c('span',[_c('aha-icon',{staticClass:"-mt-2",attrs:{"name":"trophy-outlined","width":"36","height":"36","viewBox":"0 0 24 24"}})],1),_c('span',[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Leaderboard'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }